import React from 'react'
import { useEffect } from 'react'

// TODO: router.events is deprecated in nextjs v13, perhaps use nextjs-toploader instead?
export function useLoadingState() {
  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {
    // next/router is not available in App Router — gracefully degrade
    let router: any
    try {
      // eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
      router = require('next/router').default
      if (!router?.events) return
    } catch {
      return
    }

    const handleStart = () => setIsLoading(true)
    const handleStop = () => setIsLoading(false)

    router.events.on('routeChangeStart', handleStart)
    router.events.on('routeChangeComplete', handleStop)
    router.events.on('routeChangeError', handleStop)

    return () => {
      router.events.off('routeChangeStart', handleStart)
      router.events.off('routeChangeComplete', handleStop)
      router.events.off('routeChangeError', handleStop)
    }
  }, [])

  return { isLoading }
}
